module.exports = __webpack_public_path__ + "img/3.db75478b.png";